import React from 'react';
import { useTranslation } from 'react-i18next';
import CasualtiesComponent from '../archive/CasualtiesComponent';

const ConflictComponent = ({ report, beta }) => {
  const { t } = useTranslation();

  if (!report.conflict_type) {
    return null;
  }

  return (
    <div className="further-details">
      {beta && <div className="border-b my-4 border-[#F4F5F7]" />}
      <h2>Further Details</h2>
      <table>
        <tbody>
          <tr>
            <th>Conflict Type</th>
            <td>{t(`conflict.${report.conflict_type.toLowerCase()}`)}</td>
          </tr>
          <tr>
            <th>Details</th>
            <td>
              {report.conflict_subtypes
                .map((w) => t(`conflict.subtypes.${w.toLowerCase()}`))
                .join(', ')}
            </td>
          </tr>
          <CasualtiesComponent casualties={report.casualties} />
        </tbody>
      </table>
    </div>
  );
};

export default ConflictComponent;
